var _a, _b;
import { __assign, __spreadArray } from "tslib";
import { handleActions } from 'redux-actions';
import { publishCommentSuccess } from '../../../CommentBox/actionCreators';
import { replyClosed } from './actionCreators';
import { reduxKey } from './constants';
var reducer = handleActions((_a = {},
    _a[publishCommentSuccess.toString()] = function (state, action) {
        var _a, _b;
        var ids = (_a = state === null || state === void 0 ? void 0 : state.replyAutoOpenExcludedIds) !== null && _a !== void 0 ? _a : [];
        var parentId = (_b = action.payload.comment) === null || _b === void 0 ? void 0 : _b.parentId;
        if (parentId && !ids.includes(parentId)) {
            return __assign(__assign({}, state), { replyAutoOpenExcludedIds: __spreadArray(__spreadArray([], ids, true), [parentId], false) });
        }
        return state;
    },
    _a[replyClosed.toString()] = function (state, action) {
        var _a;
        var ids = (_a = state === null || state === void 0 ? void 0 : state.replyAutoOpenExcludedIds) !== null && _a !== void 0 ? _a : [];
        if (!ids.includes(action.payload.commentId)) {
            return __assign(__assign({}, state), { replyAutoOpenExcludedIds: __spreadArray(__spreadArray([], ids, true), [action.payload.commentId], false) });
        }
        return state;
    },
    _a), {});
export default (_b = {}, _b[reduxKey] = reducer, _b);
//# sourceMappingURL=reducers.js.map